import { useCallback, useEffect, useState } from "react";

import { RUNTIME_PATIENT_AUTH_REQUIRED } from "../treatmentApiConstants";

/**
 * Remembers that the patient already signed in on the "sign in again" prompt. If the
 * saved session is refused AGAIN after that, the account is not the one that started
 * it. The memory ends when a resume succeeds (no error, nothing loading), so a later
 * prompt starts clean; while a resume is running it is kept.
 */
export const useDifferentAccountNotice = ({ errorCode, loading }) => {
  const [attempted, setAttempted] = useState(false);

  useEffect(() => {
    if (attempted && !errorCode && !loading) setAttempted(false);
  }, [attempted, errorCode, loading]);

  const markSignInAttempt = useCallback(() => setAttempted(true), []);

  return {
    differentAccount: attempted && errorCode === RUNTIME_PATIENT_AUTH_REQUIRED,
    markSignInAttempt,
  };
};
